module.exports = __webpack_public_path__ + "assets/functionalityPlusSmall-f76fbc.svg";